import {ChangeDetectorRef, Component, ComponentFactoryResolver,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {Owner} from "../../../model/customer/owner";
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import {Broker} from "../../../model/customer/broker";
import {CustomerBrokerService} from "../../../services/customer/customer-broker.service";
import {BankAccount} from "../../../model/customer/bank-account";
import TYPE = FormFieldConfig.TYPE;

@Component({
  selector: 'app-broker',
  templateUrl: './broker.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class BrokerComponent extends CrudBaseComponent<Broker> {

  //fields
  countries: FieldRecord<any>[]
  currencies: FieldRecord<string>[]

  vatRates: FieldRecord<any>[] = [];
  bankAccounts: FieldRecord<BankAccount>[] = [];

  // displayBankAccounts: FieldRecord<BankAccount>[] = [];

  constructor(cdref: ChangeDetectorRef,
              customerBrokerService: CustomerBrokerService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = customerBrokerService;
    this.newRecord = new Broker();
    this.prepareForEdit = this.prepareRecordForEdit;
    this.prepareForClone = this.prepareRecordForClone;
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'code',
      },
      {
        field: 'description',
      },
      {
        field: 'country',
        icon: (value: Owner) => value.country ? 'flag-icon flag-icon-' + value.country.toLowerCase() : '',
        mapId: value => ''
      },
      {
        field: 'currency',
        icon: record => 'cc-ico',
        iconValue: record => {
          const currency = this.currencies ? this.currencies.find(value => value.id === record.currency) : undefined;
          if (currency)
            return currency.value
          return '';
        }
      },
    ];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'code',
            required: true,
            column: 3,
            type: TYPE.TEXT,
          },
          {
            field: 'description',
            column: 4,
            type: TYPE.TEXT
          },]
      },
      {
        group: 'address',
        fields: [
          {
            field: 'address',
            column: 12,
            type: TYPE.TEXT
          },
          {
            field: 'zipCode',
            column: 3,
            type: TYPE.TEXT
          },
          {
            field: 'town',
            column: 3,
            type: TYPE.TEXT
          },
          {
            field: 'country',
            filter: true,
            column: 3,
            type: TYPE.DROPDOWN,
            icon: id => id ? ('flag-icon flag-icon-' + id.toLowerCase()) : '',
            options: () => this.countries,
            changed: event => {
              this.formRecord.country = event.value.toUpperCase();
              this.refreshVatRates();
            }
          },
        ]
      },
      {
        group: 'invoice_detail',
        fields: [
          {
            field: 'currency',
            column: 3,
            type: TYPE.DROPDOWN,
            filter: true,
            options: () => this.currencies,
            icon: id => 'cc-ico',
            iconValue: id => {
              const currency = this.currencies && this.currencies.find(value => value.id === id) ?
                this.currencies.find(value => value.id === id) : undefined;
              if (currency)
                return currency.value
              return '';
            }
          },
          {
            field: 'billingDueNbDays',
            column: 3,
            type: TYPE.INTEGER
          },
          {
            field: 'bankAccountId',
            column: 3,
            type: TYPE.DROPDOWN,
            options: () => this.bankAccounts,
          },
          {
            field: 'outstandingDebt',
            column: 3,
            type: TYPE.INTEGER
          },
          {
            field: 'invoiceMail',
            column: 12,
            type: TYPE.TEXT
          },
          {
            field: 'vatRateId',
            column: 3,
            type: TYPE.DROPDOWN,
            options: () => this.vatRates,
            changed: event => this.formRecord.vatRateId = event.value
          },,
          {
            field: 'vatNumber',
            column: 3,
            type: TYPE.DROPDOWN,
            options: () => this.vatRates,
            changed: event => this.formRecord.vatRateId = event.value
          },
        ]
      }
    ];
  }

  protected initData() {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;
    this.commonFieldService.getCountries(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.settingsFormLoadingProgressValue += 100 / 4;
      this.countries = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.refreshVatRates();
    });
    this.commonFieldService.getCurrencies(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.settingsFormLoadingProgressValue += 100 / 4;
      this.currencies = fieldResult.records ? [...this.getFields(fieldResult)] : [];
    });
    this.commonFieldService.getBankAccounts(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.settingsFormLoadingProgressValue += 100 / 4;
      this.bankAccounts = fieldResult.records ? [...this.getFields(fieldResult)] : [];
    });
  }

  refreshVatRates() {
    if (this.formRecord) {
      this.formLoading = true;
      this.commonFieldService.getVatRates(new FieldRequest(this.formRecord.country, undefined)).subscribe(fieldResult => {
        this.vatRates = this.getFields(fieldResult);
        if (this.settingsFormLoadingProgressValue < 100)
          this.settingsFormLoadingProgressValue += 100 / 4;
        this.formLoading = false;
      })
    } else {
      this.formLoading = false;
    }
  }

  // private filterBankAccount() {
  //   if (this.bankAccounts&&this.formRecord) {
  //     this.displayBankAccounts = this.bankAccounts.filter(field =>{
  //       return this.formRecord.owner === field.value.owner;
  //     });
  //   } else {
  //     this.displayBankAccounts = [];
  //   }
  // }

  onFormShow() {
    this.refreshVatRates();
  }

  prepareRecordForEdit(): void {
    if (this.formRecord) {
      this.formRecord.originCode = this.formRecord.code;
    }
  }

  prepareRecordForClone(): void {
    if (this.formRecord) {
      this.formRecord.originCode = '';
    }
  }
}
